import { render, staticRenderFns } from "./Invoices.vue?vue&type=template&id=4d6c6334&scoped=true"
import script from "./Invoices.vue?vue&type=script&lang=ts"
export * from "./Invoices.vue?vue&type=script&lang=ts"
import style0 from "./Invoices.vue?vue&type=style&index=0&id=4d6c6334&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d6c6334",
  null
  
)

export default component.exports